/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography } from '@mui/material';
import { fonts, themes } from '../../../../common/themes/themes';
import CustomCard from '../../../../common/components/CustomCard';

import VerticalBarController from '../../../../common/components/VerticalBar/VerticalBarController';

interface propsType {
  offboardingData: any;
  trans?: any;
}

const OffBoardingHistoryPresenter: React.FC<propsType> = ({
  offboardingData,
  trans,
}) => {
  return (
    <CustomCard
      cardSize={{ card_title: trans('Status') }}
      cardHeight="757px"
      cardWidth="auto"
    >
      {(offboardingData?.status == 0 ||
        offboardingData?.status == 1 ||
        offboardingData?.status == 2) && (
        <>
          <Grid
            container
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'flex-end',
              justifyContent: 'right',
            }}
          >
            <Grid
              item
              style={{
                backgroundColor:
                  offboardingData.status == 1 ? '#EDF7ED ' : '#FEECEA',

                width: 'auto',
                padding: '5px',
                borderRadius: '5px',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'flex-end',
                justifyContent: 'right',
              }}
            >
              <Typography
                style={{
                  fontFamily: fonts.fontFamily,
                  fontSize: fonts.title,
                  textAlign: 'center',
                }}
              >
                {offboardingData.status == 0 ? (
                  <span style={{ color: themes.defaultError }}>
                    {trans('Pending')}
                  </span>
                ) : offboardingData.status == 1 ? (
                  <span
                    style={{
                      color: themes.defaultSuccess,
                    }}
                  >
                    {trans('Approved')}
                  </span>
                ) : offboardingData.status == 2 ? (
                  <span style={{ color: themes.defaultError }}>
                    {trans('Rejected')}
                  </span>
                ) : (
                  ''
                )}
              </Typography>
            </Grid>
          </Grid>

          <Grid
            container
            style={{
              marginTop: '1em',
              border: '1px solid #0000001F',
              borderRadius: '15px',
              padding: '28px',
            }}
          >
            <VerticalBarController
              instanceId={offboardingData?.workflow_instance?.id}
            />
          </Grid>
        </>
      )}
    </CustomCard>
  );
};

export default OffBoardingHistoryPresenter;
